module.exports = __webpack_public_path__ + "static/img/icon-part2-1.781a824.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icon-part2-1.png
// module id = rwyQ
// module chunks = 1